import ErrorBoundary from "./components/ErrorBoundary";
import Header from "./components/Header";
import Footer from "./components/Footer";
import './css/App.css';
import { useSession } from "./components/SessionProvider";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
const App = () => {
  const mainSiteUrl = import.meta.env.VITE_MAIN_SITE_URL;
  const { userLogin, loading, siteCount } = useSession();
  const baseName = import.meta.env.VITE_APP_BASE_URL;
  const isDevelopment = import.meta.env.VITE_APP_ENV === 'development';

  return (

    <ErrorBoundary>
      <BrowserRouter basename={baseName}>

        {userLogin && siteCount ? (
          <div className="App">
            <Header />
            <Footer />
            <AppRoutes />
          </div>
        ) : (
          <>
            {loading ? <p className="m-5 text-center">Loading...</p> : ''}

            {userLogin && !siteCount && (
              <p className="m-5 text-center">You don't have any sites assigned to you or not part of the correct group.
                <br></br>For assistance, please send an email to: <a href="mailto:operations@oxfordbuilders.ca">operations@oxfordbuilders.ca</a>
                <br></br><br></br>
                <a className="btn btn-primary" href={`${mainSiteUrl}dashboard`}>Return to Dashboard</a></p>

            )}
            {!loading && !userLogin && (
              <p className="m-5 text-center">Your session has expired. Please sign in again to continue.
                {isDevelopment && (
                  <p><em>(If you are logged in, then a code deployment is in progress.)</em></p>
                )}
                <br></br><br></br>
                <a className="btn btn-primary" href={`${mainSiteUrl}?oxford_login=1`}>Login</a></p>

            )}
          </>
        )}
      </BrowserRouter>
    </ErrorBoundary>


  );
}

export default App;
